import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMedicalCrossCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"medical-cross-circle, first-aid, emergency"} maskId="square-filled-radius-0-stroke-1-IconMedicalCrossCircle"><path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM10.5 10.5H8V13.5H10.5V16H13.5V13.5H16V10.5H13.5V8H10.5V10.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMedicalCrossCircle;
